import { Theme, css } from '@emotion/react';

import { Radius, Spacing, Typography } from 'chatie-design-system';

export const floatingButtonCSS = (theme: Theme) => css`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: ${Spacing.medium}px;
  right: ${Spacing.medium}px;
  width: 64px;
  height: 64px;
  border-radius: ${Radius.round}px;
  z-index: 100;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.4);
  background: linear-gradient(34.71deg, #20a2ae 3.8%, #5563e1 84.21%);

  ${Typography.h6};
  font-size: 12px;
  text-align: center;
  line-height: 16.2px;
  color: ${theme.var.white};
`;

export interface FloatingContentProps {
  text: string;
  handleOnClick: () => void;
}

export interface FloatingSelectButtonProps {
  isOpen: boolean;
  onClose: () => void;
  contents: FloatingContentProps[];
  buttonText: string;
}

const FloatingCreateButton = ({
  handleOnClick,
}: {
  handleOnClick: () => void;
}) => {
  return (
    <div
      css={floatingButtonCSS}
      className={'floating-create'}
      onClick={handleOnClick}
    >
      <p>
        캐릭터
        <br />
        만들기
      </p>
    </div>
  );
};

export default FloatingCreateButton;
